import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import { save, destroy }        from "apps/actions/common";
import {
  Global,
  ScrollModel
} from '../model';
import {
  PLANNER_SCROLL_SET_GETTERS,
  PLANNER_SCROLL_TAB_POSITION,
  PLANNER_SCROLL_CONTENT_POSITION,
  PLANNER_SCROLL_UPDATED,
  PLANNER_SCROLL_CHANGE_NATIVES,
  PLANNER_SCROLL_SCROLL
} from 'apps/events';
import PlannerControllerBase from './base';
export default class ScrollController extends PlannerControllerBase {
  scrollModel: ScrollModel;
  constructor(tag){
    super(tag);
    this.scrollModel = new ScrollModel();
    this.customEvent(PLANNER_SCROLL_SET_GETTERS, (e)  => { this.setGetter(e) });
    this.customEvent(PLANNER_SCROLL_SCROLL, (e)  => { this.onScroll(e) });
  }
  //
  setGetter(e){
    if(e.detail.getScrollWidth){
      this.scrollModel.getScrollWidth = e.detail.getScrollWidth
    }
    if(e.detail.getContainerWidth){
      this.scrollModel.getContainerWidth = e.detail.getContainerWidth
    }
    if(e.detail.getContentWidth){
      this.scrollModel.getContentWidth = e.detail.getContentWidth
    }
    if(this.scrollModel.isPreparedGetter()){
      this.scrollModel.setResizeEvent(PLANNER_SCROLL_CHANGE_NATIVES);
      this.scrollModel.updateScale();
      this.dispatchEvent();
    }
  }
  dispatchEvent(){
    let detail = this.scrollModel;
    let customEvent = new CustomEvent(PLANNER_SCROLL_UPDATED, {detail: detail});
    document.dispatchEvent(customEvent);
  }
  onScroll(e){
    let newLeft = e.detail;
    this.scrollModel.updateScrollPosition(newLeft);
    this.updateTabPosition();
    this.updateContentPosition();
  }
  updateTabPosition(){
    let detail = this.scrollModel;
    let customEvent = new CustomEvent(PLANNER_SCROLL_TAB_POSITION, {detail: detail});
    document.dispatchEvent(customEvent);
  }
  updateContentPosition(){
    let detail = this.scrollModel;
    let customEvent = new CustomEvent(PLANNER_SCROLL_CONTENT_POSITION, {detail: detail});
    document.dispatchEvent(customEvent);
  }
}
